
      import { createComponent } from '@lit/react'
      import { type EventName } from '@lit/react'
      import * as React from 'react'

      import Component from '../../components/command/command-item.js'
      import type { DdsCommandItemClickEvent } from '../../events/events'
      export type { DdsCommandItemClickEvent } from '../../events/events'

      const tagName = 'dap-ds-command-item'

      /**
 * `dap-ds-command-item`
 * @summary A command item is a command item that can be selected.
 * @element dap-ds-command-item
 * @title - Command item
 * @group command
 *
 * @event {{ value: string, closeOnSelect: boolean }} dds-command-item-click - Fired when the command item is clicked.
 *
 * @slot - The label of the command item.
 * @slot check - The check of the command item.
 *
 * @csspart base - The base part of the command item.
 * @csspart content - The content part of the command item.
 * @csspart label - The label part of the command item.
 *
 * @cssproperty --dds-command-item-padding - The padding of the command item (default: var(--dds-spacing-100) var(--dds-spacing-200))
 * @cssproperty --dds-command-item-background - The background color of the command item (default: none)
 * @cssproperty --dds-command-item-color - The text color of the command item (default: var(--dds-text-primary-base))
 * @cssproperty --dds-command-item-hover-background - The background color of the command item on hover (default: var(--dds-transparent-black-subtle))
 * @cssproperty --dds-command-item-selected-background - The background color of the selected command item (default: var(--dds-transparent-black-subtle))
 */
      const reactWrapper = createComponent({
        tagName,
        elementClass: Component,
        react: React,
        events: {
          onDdsCommandItemClick: 'dds-command-item-click' as EventName<DdsCommandItemClickEvent>
        },
        displayName: "DapDSCommandItem"
      })

      export default reactWrapper
    